import type { ReactNode } from 'react';

export function MenuItems({ children }: { children: ReactNode }) {
  return (
    <ul className="mobile-nav-items flex flex-col items-stretch gap-1 py-4 max-lg:w-full max-lg:gap-2.5 lg:flex-row lg:items-center lg:gap-0">
      {children}
    </ul>
  );
}
